import { createAsyncActionType } from './index';

export const GET_ALL_NEWS_FEED = createAsyncActionType('allNewsFeed', 'GET_ALL_NEWS_FEED');
export const GET_COMMENTS_BY_NEWS_FEED = createAsyncActionType('allNewsFeed', 'GET_COMMENTS_BY_NEWS_FEED');
export const RESET_COMMENTS_NEWS_FEED  = createAsyncActionType('allNewsFeed', 'RESET_COMMENTS_NEWS_FEED');
export const GET_NEWS_FEED_USERLIKE = createAsyncActionType('allNewsFeed', 'GET_NEWS_FEED_USERLIKE');
export const ADD_COMMENT_TO_NEWS_FEED = createAsyncActionType('allNewsFeed', 'ADD_COMMENT_TO_NEWS_FEED');
export const UPDATE_NEWS_FEED_COMMENT = createAsyncActionType('allNewsFeed', 'UPDATE_NEWS_FEED_COMMENT');
export const DELETE_NEWS_FEED = createAsyncActionType('allNewsFeed', 'DELETE_NEWS_FEED');
export const DELETE_NEWS_FEED_COMMENT = createAsyncActionType('allNewsFeed', 'DELETE_NEWS_FEED_COMMENT');